import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/session", { params: { session_id: sessionId } });
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: data } });
      } catch {
        navigate("/admin", { replace: true, state: { error: "Login non riuscito. Riprova." } });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B]" data-testid="auth-callback-loading">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#C5A059]">
        Accesso in corso...
      </p>
    </div>
  );
}
